export const PARAMETERS_CODE = {
  FAQ_TEXT_FEEDBACK_PARAMETER_CODE: 'ENABLE_FAQ_FEEDBACK',
  ENABLE_SEARCH_FAQ_AI: 'ENABLE_SEARCH_FAQ_AI',
}
